import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Box,
  Stack,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  Typography,
} from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import TablePaginations from 'src/components/table-pagination/TablePaginations';

export default function DateInpuCard({ question }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const { t } = useTranslation();
  const { isSmallScreen } = useResponsiveScreen();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Stack
        direction="row"
        alignItems="flex-start"
        px={2}
        justifyContent="space-between"
        gap={2}
      >
        <Typography
          variant="subtitle1"
          sx={{
            mb: 0.5,
            fontSize: isSmallScreen ? '0.8rem' : '1rem',
            fontWeight: 'bold',
            flex: 1,
            minWidth: 200,
            wordBreak: 'break-word',
          }}
        >
          {question.questionText}
        </Typography>

        <Typography
          variant="caption"
          color="info.dark"
          sx={{ whiteSpace: 'nowrap', alignSelf: 'flex-start' }}
        >
          {t(`surveyDashboard.${question.questionType}`)}
        </Typography>
      </Stack>

      <Table size="small" sx={{ mt: 1 }}>
        <TableHead>
          <TableRow>
            <TableCell>{t('surveyDashboard.date')}</TableCell>
            <TableCell align="right">{t('surveyDashboard.occurrences')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.entries(question.responseCount || {})
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map(([date, count]) => (
              <TableRow key={date}>
                <TableCell>{date}</TableCell>
                <TableCell align="right">{count}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>

      <TablePaginations
        filteredEntity={Object.entries(question.responseCount || {})}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[5]}
      />
    </Box>
  );
}

DateInpuCard.propTypes = {
  question: PropTypes.object,
};
